class TabChange {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    
    (function ($) {
      const item01 = document.querySelector('#pg-1089-0');
      const item02 = document.querySelector('#pg-1089-1');
      item01.classList.add('tabChange');
      item01.classList.add('is-show');
      item02.classList.add('tabChange');

      //任意のタブにURLからリンクするための設定
      function GethashID (hashIDName){
        console.log(hashIDName);
        if(hashIDName){
          //タブ設定
          $('.tabMenu__item').find('a').each(function() {
            var idName = $(this).attr('href');
            if(idName == hashIDName){
              var parentElm = $(this).parent(); //タブ内のaタグの親要素（li）を取得
              $('.tabMenu__item').removeClass("is-active"); //タブ内のliについているactiveクラスを取り除き
              $(parentElm).addClass("is-active"); //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
              //表示させるエリア設定
              $(".tabChange").removeClass("is-show"); 
              $(hashIDName).addClass("is-show"); 
            }
          });
        }
      }
    
      //タブをクリックしたら
      $('.tabMenu__item a').on('click', function() {
        var idName = $(this).attr('href'); //タブ内のリンク名を取得	
        $('.tabMenu__item').removeClass("is-active");
        GethashID (idName);//設定したタブの読み込みと
        return false;//aタグを無効にする
      });
    
      // 上記の動きをページが読み込まれたらすぐに動かす
      $(window).on('load', function () {
          $('.tabMenu__item:nth-of-type(1)').addClass("is-active"); //最初のliにactiveクラスを追加
          $('.tabChange:nth-of-type(1)').addClass("is-show"); //最初の.areaにis-activeクラスを追加
        var hashName = location.hash; //リンク元の指定されたURLのハッシュタグを取得
        GethashID (hashName);//設定したタブの読み込み
      });
    
    })(jQuery);
  }
}
